//USER AUTHORIZATION
export const POST_LOGIN = "/auth/login";
export const POST_REGISTER = "/auth/register";
export const POST_LOGOUT = "/auth/logout";
export const POST_FIRST_LOGIN_UPDATE_USER_PASSWORD = "/auth/first-password-change"
export const POST_CHANGE_PASSWORD = "/auth/change-password"
export const POST_REQUEST_PASSWORD_RESET = "/auth/request-password-reset";
export const POST_VALIDATE_RESET_TOKEN = "/auth/validate-reset-token";
export const POST_RESET_PASSWORD = "/auth/reset-password";

//ADMIN USER MANAGEMENT
export const POST_ACTIVATE_USER = "/users/activate-user";
export const POST_UPDATE_USER_PERMISSIONS = "/users/update-permissions";
export const POST_UPDATE_USER_ROLE = "/users/update-role";
export const POST_DELETE_USER = "/users/delete-user";
export const POST_CREATE_USER = "/users/create-user";
export const POST_RESEND_INVITE = "/users/resend-invite";
export const POST_CHECK_ERP_EMAIL = "/users/check-erp-email";
export const POST_UPDATE_ERP_LINK = "/users/update-erp-link";

//USER SHIPPING ADRESSES
export const POST_ADD_USER_ADDRESS = "/auth/addAddress";
export const POST_GET_USER_ADDRESS = "/auth/userAddresses";
export const POST_REMOVE_USER_ADDRESS = "/auth/removeAddress";

//ORDERS
export const POST_CREATE_ORDER = "/orders/create-order"
export const POST_GET_ORDERS = "/orders/user-orders"
export const POST_GET_ORDER_DETAILS = "/orders/order-details"
export const POST_UPDATE_ORDER_ITEM_NOTE = "/orders/order-details/update-note"

//SAVED CARTS
export const POST_GET_USER_SAVED_CARTS = "/saved-carts/user-carts"
export const POST_ADD_USER_SAVED_CART = "/saved-carts/add"
export const POST_DELETE_USER_SAVED_CART = "/saved-carts/delete"

//ACTIVE CART
export const POST_GET_USER_CART = "/carts/user-cart"
export const POST_VALIDATE_USER_CART = "/carts/validate"
export const POST_ADD_CART_ITEMS = "/carts/bulk-add"
export const POST_UPDATE_CART_ITEM = "/carts/update-item"
export const POST_UPDATE_CART_ITEM_NOTES = "/carts/update-item-notes"
export const POST_REMOVE_CART_ITEM = "/carts/remove-item"
export const POST_REMOVE_CART_ITEMS = "/carts/remove-items"
export const POST_CLEAR_CART = "/carts/clear"
export const POST_SAVE_ACTIVE_CART = "/carts/save"
export const POST_REPLACE_CART_FROM_SAVED = "/carts/replace-from-saved"
export const POST_REPLACE_CART = "/carts/replace"

//SUBACCOUNTS
export const POST_GET_USER_SUBACCOUNTS = "/subaccount/user-subaccounts"
export const POST_ADD_USER_SUBACCOUNT = "/subaccount/add"
export const POST_UPDATE_USER_SUBACCOUNT = "/subaccount/update"
export const POST_DELETE_USER_SUBACCOUNT = "/subaccount/delete"

//FAVORITES
export const POST_GET_USER_FAVORITES = "/favorites/user-favorites"
export const POST_ADD_USER_FAVORITE = "/favorites/add"
export const POST_DELETE_USER_FAVORITE = "/favorites/delete"
export const POST_UPDATE_USER_FAVORITE_NAME = "/favorites/update-name"

//SALES OFFERS
export const POST_GET_SALES_OFFER_CLIENTS = "/sales-offers/clients"
export const POST_GET_SALES_OFFERS = "/sales-offers/list"
export const POST_GET_SALES_OFFER_DETAILS = "/sales-offers/details"
export const POST_CREATE_SALES_OFFER = "/sales-offers/create"
export const POST_UPDATE_SALES_OFFER = "/sales-offers/update"
export const POST_PUBLISH_SALES_OFFER = "/sales-offers/publish"
export const POST_RENEW_SALES_OFFER = "/sales-offers/renew"
export const POST_COPY_SALES_OFFER_TO_CART = "/sales-offers/copy-to-cart"

//INVOICES
export const POST_GET_USER_INVOICES = "/shadowapi/user-invoices"
export const POST_GET_INVOICE_PDFS = "/invoices/list"
export const GET_INVOICE_PDF_DOWNLOAD = "/invoices/download"

//DOWNLOAD CENTRE
export const GET_DOWNLOAD_CENTRE = "/downloads/centre"
export const GET_DOWNLOAD_FILE = "/downloads/file"
export const DOWNLOAD_ADMIN = "/downloads/admin"

//CONTACT-FORM
export const POST_CONTACT_FORM = "/auth/contact-form"

//DASHBOARD
export const POST_GET_DASHBOARD_DATA = "/dashboard"



//ADMIN
export const POST_GET_ALL_ORDERS = "/orders/all-orders"
export const POST_GET_ALL_USERS = "/users/all-users"
export const POST_GET_USER_SHADOW_DATA = "/users/shadow-data"
export const POST_TEST_POSTGRES_CONNECTION = "/admin-tools/postgres/test-connection"
export const POST_RUN_POSTGRES_QUERY = "/admin-tools/postgres/query"
export const POST_SYNC_POSTGRES_INDEKSY = "/admin-tools/postgres/sync-indeksy"
export const POST_SYNC_POSTGRES_TLUMACZENIA = "/admin-tools/postgres/sync-tlumaczenia"
export const POST_SYNC_POSTGRES_KLASYFIKACJE_TOWAROW = "/admin-tools/postgres/sync-klasyfikacje-towarow"
export const POST_SYNC_POSTGRES_CECHY_DOSTAW = "/admin-tools/postgres/sync-cechy-dostaw"
export const POST_SYNC_POSTGRES_WARTOSCI_ZALEZNE = "/admin-tools/postgres/sync-wartosci-zalezne"
export const POST_SYNC_POSTGRES_CENNIKI = "/admin-tools/postgres/sync-cenniki"



//rob.com.pl
export const GET_BLIND_MODELS = "/shadowapi/blind-models"
export const GET_SHADOW_NEWS = "/shadowapi/news"
export const GET_PRODUCTION_TERMS = "/production-terms"
export const GET_PRODUCTION_TERM_GROUPS = "/production-terms/groups"
export const GET_TOOLS = "/tools"
export const POST_ESTIMATE_PRODUCTION_TERM = "/production-terms/estimate"
export const GET_SHADOW_ORDERS = "/shadowapi/orders"
export const GET_SHADOW_ORDER_DETAILS = "/shadowapi/order"
export const GET_BLIND_PRICE = "/shadowapi/blind-data/price"
export const GET_FABRIC_AVAILABILITY = "/shadowapi/fabric-availability"
export const GET_PRODUCT_RELATIONS = "/shadowapi/relations"


//NEW SHADOW API
export const GET_BLIND_DATA = "/shadowapi/blind-data"
export const GET_PRODUCT_TYPES = "/newshadowapi/all-products"
export const GET_NEW_BLIND_PRICE = "/newshadowapi/blind-data/price"
export const GET_NEW_PRODUCT_RELATIONS = "/newshadowapi/relations"
export const GET_SYNC_CONFIGURATOR_CATALOG = "/newshadowapi/sync-configurator/catalog"
export const GET_SYNC_CONFIGURATOR_PRODUCT = "/newshadowapi/sync-configurator/product"
export const POST_SYNC_CONFIGURATOR_PRICE = "/newshadowapi/sync-configurator/price"
